import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { GameState } from '../enums/GameState';

@Injectable({ providedIn: 'root' })
export class GameStateServiceService {
    playerDied$ = new Subject<void>();
    gameState$ = new BehaviorSubject<GameState>(GameState.Default);

    reset(): void {
        this.gameState$.next(GameState.Default);
    }
}
